export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./brands.vue?vue&type=template&id=5cd0bb60&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/brands.vue?vue&type=template&id=5cd0bb60&
// module id = 48
// module chunks = 0